<template>
  <div v-if="!loading">
    <v-row justify="center" class="mx-5 mx-sm-0">
      <v-col cols="12" sm="6">
        <Title
          icon="mdi-information"
          tooltip="Your personal client ID and secret ID can be found in the portal of FeedbackCompany. Per website with Feedback Company there’ll be unique credentials"
          title="Authentication"
        />
      </v-col>
    </v-row>
    <Form />
    <v-row justify="end">
      <v-btn
        class="ml-5 mb-5"
        :class="isDisabledNextPage || 'main-btn'"
        :disabled="isDisabledNextPage"
        @click="goToSettings"
      >
        Next step
      </v-btn>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  name: "AuthenticationPage",

  components: {
    Title: () => import("@/components/Title.vue"),
    Form: () => import("@/views/Authentication/components/Form.vue"),
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(["loading"]),
    ...mapState("Auth", ["isDisabledNextPage"]),
  },
  async mounted() {
    try {
      this.setLoading(true);
      await this.getCreditsUser();
      this.setDisabledNextPage(false);
      this.setDisabledPage({ page: "settings", bool: false });
      this.setDisabledPage({ page: "widgets", bool: false });
      this.setDisabledPage({ page: "logs", bool: false });
    } catch (e) {
      this.setDisabledPage({ page: "settings", bool: true });
      this.setDisabledPage({ page: "widgets", bool: true });
      this.setDisabledPage({ page: "logs", bool: true });
      this.setDisabledNextPage(true);
    }
    this.setLoading(false);
  },

  methods: {
    ...mapMutations("Pages", ["setDisabledPage"]),
    ...mapMutations(["setLoading"]),
    ...mapMutations("Auth", ["setDisabledNextPage"]),
    ...mapActions("Auth", ["getCreditsUser"]),
    goToSettings() {
      this.setDisabledPage({ page: "settings", bool: false });
      this.$router.push({ name: "Settings" });
    },
  },
};
</script>
